import type { VariantImagesDefinition } from 'types/images'

import { M01_IMAGES } from './default'

export const M01_REALISTIC_IMAGES = {
  welcomeAgeBuckets: {
    heroBackground: {
      ...M01_IMAGES.welcomeAgeBuckets.heroBackground,
      srcSet: [
        '/images/m01/realistic/welcome-age-buckets/hero_background.webp',
        '/images/m01/realistic/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
    heroBackgroundDesktop: {
      ...M01_IMAGES.welcomeAgeBuckets.heroBackgroundDesktop,
      srcSet: [
        '/images/m01/realistic/welcome-age-buckets/hero_background_desktop.webp',
        '/images/m01/realistic/welcome-age-buckets/hero_background_desktop@2x.webp',
      ],
    },
  },
  socialProofMillions: {
    pitch: {
      ...M01_IMAGES.socialProofMillions.pitch,
      srcSet: [
        '/images/m01/realistic/social_proof_millions.webp',
        '/images/m01/realistic/social_proof_millions@2x.webp',
      ],
    },
    group: {
      ...M01_IMAGES.socialProofMillions.group,
      srcSet: [
        '/images/m01/realistic/social-proof-millions/group.webp',
        '/images/m01/realistic/social-proof-millions/group@2x.webp',
      ],
    },
  },
  experience: {
    background: {
      ...M01_IMAGES.experience.background,
      srcSet: [
        '/images/m01/realistic/experience.webp',
        '/images/m01/realistic/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...M01_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/m01/realistic/experience_pitch.webp',
        '/images/m01/realistic/experience_pitch@2x.webp',
      ],
    },
  },
  mainGoal: {
    gainMuscle: {
      ...M01_IMAGES.mainGoal.gainMuscle,
      srcSet: [
        '/images/m01/realistic/main-goal/main_goal_option_gain_muscle.webp',
        '/images/m01/realistic/main-goal/main_goal_option_gain_muscle@2x.webp',
      ],
    },
    improveFitness: {
      ...M01_IMAGES.mainGoal.improveFitness,
      srcSet: [
        '/images/m01/realistic/main-goal/main_goal_option_improve_fitness.webp',
        '/images/m01/realistic/main-goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseWeight: {
      ...M01_IMAGES.mainGoal.loseWeight,
      srcSet: [
        '/images/m01/realistic/main-goal/main_goal_option_lose_weight.webp',
        '/images/m01/realistic/main-goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  struggle: {
    back: {
      ...M01_IMAGES.struggle.back,
      srcSet: [
        '/images/m01/realistic/struggle/struggle_option_back.webp',
        '/images/m01/realistic/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      ...M01_IMAGES.struggle.knees,
      srcSet: [
        '/images/m01/realistic/struggle/struggle_option_knees.webp',
        '/images/m01/realistic/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      ...M01_IMAGES.struggle.none,
      srcSet: [
        '/images/m01/realistic/struggle/struggle_option_none.webp',
        '/images/m01/realistic/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      ...M01_IMAGES.bodyTypePitch.endomorph,
      srcSet: [
        '/images/m01/realistic/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/m01/realistic/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      ...M01_IMAGES.bodyTypePitch.mesomorph,
      srcSet: [
        '/images/m01/realistic/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/m01/realistic/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      ...M01_IMAGES.bodyTypePitch.ectomorph,
      srcSet: [
        '/images/m01/realistic/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/m01/realistic/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      ...M01_IMAGES.strugglePitch.knees,
      srcSet: [
        '/images/m01/realistic/struggle-pitch/struggle_pitch_knees.webp',
        '/images/m01/realistic/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      ...M01_IMAGES.strugglePitch.back,
      srcSet: [
        '/images/m01/realistic/struggle-pitch/struggle_pitch_back.webp',
        '/images/m01/realistic/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      ...M01_IMAGES.strugglePitch.both,
      srcSet: [
        '/images/m01/realistic/struggle-pitch/struggle_pitch_both.webp',
        '/images/m01/realistic/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extra: {
      ...M01_IMAGES.physicalBuild.extra,
      srcSet: [
        '/images/m01/realistic/physical-build/physical_build_option_significantly_overweight.webp',
        '/images/m01/realistic/physical-build/physical_build_option_significantly_overweight@2x.webp',
      ],
    },
    plusSize: {
      ...M01_IMAGES.physicalBuild.plusSize,
      srcSet: [
        '/images/m01/realistic/physical-build/physical_build_option_bigger.webp',
        '/images/m01/realistic/physical-build/physical_build_option_bigger@2x.webp',
      ],
    },
    average: {
      ...M01_IMAGES.physicalBuild.average,
      srcSet: [
        '/images/m01/realistic/physical-build/physical_build_option_medium_build.webp',
        '/images/m01/realistic/physical-build/physical_build_option_medium_build@2x.webp',
      ],
    },
    skinnySlim: {
      ...M01_IMAGES.physicalBuild.skinnySlim,
      srcSet: [
        '/images/m01/realistic/physical-build/physical_build_option_slender.webp',
        '/images/m01/realistic/physical-build/physical_build_option_slender@2x.webp',
      ],
    },
  },
  bodyGoal: {
    bitLeaner: {
      ...M01_IMAGES.bodyGoal.bitLeaner,
      srcSet: [
        '/images/m01/realistic/body-goal/body_goal_option_a_bit_leaner.webp',
        '/images/m01/realistic/body-goal/body_goal_option_a_bit_leaner@2x.webp',
      ],
    },
    athletic: {
      ...M01_IMAGES.bodyGoal.athletic,
      srcSet: [
        '/images/m01/realistic/body-goal/body_goal_option_athletic.webp',
        '/images/m01/realistic/body-goal/body_goal_option_athletic@2x.webp',
      ],
    },
    shredded: {
      ...M01_IMAGES.bodyGoal.shredded,
      srcSet: [
        '/images/m01/realistic/body-goal/body_goal_option_shredded.webp',
        '/images/m01/realistic/body-goal/body_goal_option_shredded@2x.webp',
      ],
    },
    extraBulky: {
      ...M01_IMAGES.bodyGoal.extraBulky,
      srcSet: [
        '/images/m01/realistic/body-goal/body_goal_option_extra_bulky.webp',
        '/images/m01/realistic/body-goal/body_goal_option_extra_bulky@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      ...M01_IMAGES.problemAreas.belly,
      srcSet: [
        '/images/m01/realistic/problem-areas/problem_areas_option_belly.webp',
        '/images/m01/realistic/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    pecs: {
      ...M01_IMAGES.problemAreas.pecs,
      srcSet: [
        '/images/m01/realistic/problem-areas/problem_areas_option_pecs.webp',
        '/images/m01/realistic/problem-areas/problem_areas_option_pecs@2x.webp',
      ],
    },
    arms: {
      ...M01_IMAGES.problemAreas.arms,
      srcSet: [
        '/images/m01/realistic/problem-areas/problem_areas_option_arms.webp',
        '/images/m01/realistic/problem-areas/problem_areas_option_arms@2x.webp',
      ],
    },
    thighs: {
      ...M01_IMAGES.problemAreas.thighs,
      srcSet: [
        '/images/m01/realistic/problem-areas/problem_areas_option_legs.webp',
        '/images/m01/realistic/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      ...M01_IMAGES.howOftenExercise.background,
      srcSet: [
        '/images/m01/realistic/how_often_exercise.webp',
        '/images/m01/realistic/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      ...M01_IMAGES.howOftenWalks.background,
      srcSet: [
        '/images/m01/realistic/how_often_walks.webp',
        '/images/m01/realistic/how_often_walks@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      ...M01_IMAGES.flexible.background,
      srcSet: [
        '/images/m01/realistic/flexible.webp',
        '/images/m01/realistic/flexible@2x.webp',
      ],
    },
  },
  goalPitch: {
    mockup: {
      ...M01_IMAGES.goalPitch.mockup,
      srcSet: [
        '/images/m01/realistic/goal-pitch/goal_pitch_mockup_{{locale}}.webp',
        '/images/m01/realistic/goal-pitch/goal_pitch_mockup_{{locale}}@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      ...M01_IMAGES.bigResultsPitch.first,
      srcSet: [
        '/images/m01/realistic/big-results-pitch/big_results_pitch_01.webp',
        '/images/m01/realistic/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
    },
    second: {
      ...M01_IMAGES.bigResultsPitch.second,
      srcSet: [
        '/images/m01/realistic/big-results-pitch/big_results_pitch_02.webp',
        '/images/m01/realistic/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
    },
    third: {
      ...M01_IMAGES.bigResultsPitch.third,
      srcSet: [
        '/images/m01/realistic/big-results-pitch/big_results_pitch_03.webp',
        '/images/m01/realistic/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
    },
    mockup: {
      ...M01_IMAGES.bigResultsPitch.mockup,
      srcSet: [
        '/images/m01/realistic/big-results-pitch/big_results_pitch_mockup_{{locale}}.webp',
        '/images/m01/realistic/big-results-pitch/big_results_pitch_mockup_{{locale}}@2x.webp',
      ],
    },
  },
  problemAreasPitch: {
    mockup: {
      ...M01_IMAGES.problemAreasPitch.mockup,
      srcSet: [
        '/images/m01/realistic/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}.webp',
        '/images/m01/realistic/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}@2x.webp',
      ],
    },
  },
  waterIntake: {
    header: {
      ...M01_IMAGES.waterIntake.header,
      srcSet: [
        '/images/m01/realistic/water_intake.webp',
        '/images/m01/realistic/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      ...M01_IMAGES.sleepDuration.header,
      srcSet: [
        '/images/m01/realistic/sleep_duration.webp',
        '/images/m01/realistic/sleep_duration@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      ...M01_IMAGES.wellnessProfile.extended,
      srcSet: [
        '/images/m01/realistic/wellness-profile/wellness_profile_overweight.webp',
        '/images/m01/realistic/wellness-profile/wellness_profile_overweight@2x.webp',
      ],
    },
    fullFigured: {
      ...M01_IMAGES.wellnessProfile.fullFigured,
      srcSet: [
        '/images/m01/realistic/wellness-profile/wellness_profile_bigger.webp',
        '/images/m01/realistic/wellness-profile/wellness_profile_bigger@2x.webp',
      ],
    },
    midSized: {
      ...M01_IMAGES.wellnessProfile.midSized,
      srcSet: [
        '/images/m01/realistic/wellness-profile/wellness_profile_medium_build.webp',
        '/images/m01/realistic/wellness-profile/wellness_profile_medium_build@2x.webp',
      ],
    },
    slim: {
      ...M01_IMAGES.wellnessProfile.slim,
      srcSet: [
        '/images/m01/realistic/wellness-profile/wellness_profile_slender.webp',
        '/images/m01/realistic/wellness-profile/wellness_profile_slender@2x.webp',
      ],
    },
  },
  subscription: {
    beforeBigger: {
      ...M01_IMAGES.subscription.beforeBigger,
      srcSet: [
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_before_bigger.webp',
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_before_bigger@2x.webp',
      ],
    },
    beforeMediumBuild: {
      ...M01_IMAGES.subscription.beforeMediumBuild,
      srcSet: [
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_before_medium_build.webp',
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_before_medium_build@2x.webp',
      ],
    },
    beforeSignificantlyOverweight: {
      ...M01_IMAGES.subscription.beforeSignificantlyOverweight,
      srcSet: [
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_before_significantly_overweight.webp',
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_before_significantly_overweight@2x.webp',
      ],
    },
    beforeSlender: {
      ...M01_IMAGES.subscription.beforeSlender,
      srcSet: [
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_before_slender.webp',
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_before_slender@2x.webp',
      ],
    },
    afterAthletic: {
      ...M01_IMAGES.subscription.afterAthletic,
      srcSet: [
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_after_athletic.webp',
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_after_athletic@2x.webp',
      ],
    },
    afterBitLeaner: {
      ...M01_IMAGES.subscription.afterBitLeaner,
      srcSet: [
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_after_a_bit_leaner.webp',
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_after_a_bit_leaner@2x.webp',
      ],
    },
    afterExtraBulky: {
      ...M01_IMAGES.subscription.afterExtraBulky,
      srcSet: [
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_after_extra_bulky.webp',
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_after_extra_bulky@2x.webp',
      ],
    },
    afterShredded: {
      ...M01_IMAGES.subscription.afterShredded,
      srcSet: [
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_after_shredded.webp',
        '/images/m01/realistic/subscription/goal-body/paywall_comparison_after_shredded@2x.webp',
      ],
    },
  },
} satisfies VariantImagesDefinition<typeof M01_IMAGES>
